module.exports = __webpack_public_path__ + "media/dpanthenol-large.07682c52.mp4";